module.exports = __webpack_public_path__ + "static/media/cvo-limited-royal-purple-fade.904757be.png";